import { BASE_USER_URL, BASE_URL } from '../store/apiConfig';
import { getAuthUser } from './auth.util';
import { getCompanyCode, getEntityCode } from '../config/axios.config';

/**
 * Build URL for /envision/api/user/cdn/:fileName?hrCoCd=…
 * Files are stored under UserImagePath/{Companycode from header}/Employee Images/.
 * Prefer session company code over JWT hrCoCd so the folder matches the API save path.
 */
export function getEmployeeFilePath(path, coCd) {
  if (!path || path === 'null') return null;
  const trimmed = String(path).trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  // Match backend folder: getUserContext().companyCode (Companycode header)
  let explicit = '';
  if (coCd != null && String(coCd).trim() !== '') {
    explicit = String(coCd).trim();
  }
  const hrCoCd =
    explicit ||
    getEntityCode() ||
    getCompanyCode() ||
    getAuthUser()?.hrCoCd?.trim() ||
    '';

  const parts = trimmed.split(/[/\\]/);
  const fileName = parts[parts.length - 1];
  if (!fileName || fileName === 'null') return null;
  const lowerPath = trimmed.toLowerCase();
  let folderHint = '';
  if (lowerPath.includes('signature')) {
    folderHint = 'signature';
  } else if (lowerPath.includes('image')) {
    folderHint = 'image';
  }

  let base = '';
  if (typeof BASE_URL === 'string' && BASE_URL) {
    base = BASE_URL.replace(/\/$/, '');
  }
  const query = new URLSearchParams({
    hrCoCd: hrCoCd || '',
  });
  if (folderHint) query.set('folder', folderHint);
  return `${base}${BASE_USER_URL}/cdn/${encodeURIComponent(fileName)}?${query.toString()}`;
}

const isLikelyRawBase64 = value =>
  typeof value === 'string' &&
  value.length > 100 &&
  !/[\\/]/.test(value) &&
  /^[A-Za-z0-9+/=\r\n]+$/.test(value);

export function resolveEmployeeImageSrc(value, coCd) {
  if (!value || value === 'null') return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;
  if (/^data:image\//i.test(trimmed)) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (isLikelyRawBase64(trimmed)) {
    const cleaned = trimmed.replace(/\s+/g, '');
    return `data:image/jpeg;base64,${cleaned}`;
  }
  return getEmployeeFilePath(trimmed, coCd);
}

export function pasrseEmployeeImageFileName(path) {
  if (!path) return null;
  const parts = path.split(/[/\\]/);
  const fileName = parts[parts.length - 1];
  return fileName;
}
